import Vue from 'vue'
import PhotoViewer from './index.vue'

Vue.prototype.$photoViewer = function(options) {
  
  var photoViewer = Vue.extend(PhotoViewer)

  var component = new photoViewer().$mount()
  
  document.body.appendChild(component.$el)

  component.show(options)
}

PhotoViewer.install=function(Vue){
  Vue.component(PhotoViewer.name,PhotoViewer);
}
export default PhotoViewer